import { post, del, put } from './requests'

export function createDocumentContact ({ documentId, contactId, copiedContact = false }) {
  return post(`documents/${documentId}/contacts`, { documentContact: { contactId, copiedContact } })
}

export function bulkCreateBuilderContacts ({ documentId, contacts, selfSigning }) {
  return post(`documents/${documentId}/contacts/bulk_create`, { contacts, selfSigning })
}

export const bulkUpdatePasscodes = ({ externalId, data }) => post(`documents/${externalId}/passcodes`, data)

export function deleteDocumentContact ({ documentId, contactId }) {
  return del(`documents/${documentId}/contacts/${contactId}`)
}

export function updateDocumentContact ({ documentableId, recipientId, data }) {
  return put(`documents/${documentableId}/contacts/${recipientId}`, { documentContact: data })
}

export function authenticateVisitor (documentId, contactId, passcode) {
  return post(`documents/${documentId}/contacts/${contactId}/authenticate_visitor`, { documentContact: { passcode } })
}
